export * from './text-area.component';
export * from './text-area.module';